function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M252.928,144.03c-1.775-3.809-6.297-5.453-10.109-3.68l-91.1,42.479c-6.145-7.725-15.59-12.445-25.704-12.445 c-2.227,0-4.418,0.246-6.571,0.687L53.559,29.785L9.599,17.888c-4.043-1.093-8.235,1.301-9.333,5.356 c-1.098,4.055,1.301,8.235,5.356,9.333l37.135,10.051l62.902,134.889c-11.618,9.219-15.902,25.527-9.366,39.552 c5.367,11.512,17.046,18.95,29.749,18.95c4.809,0,9.473-1.037,13.855-3.084c7.941-3.703,13.967-10.277,16.962-18.512 c2.108-5.793,2.503-11.915,1.286-17.804l91.1-42.479C253.058,152.364,254.704,147.839,252.928,144.03z M142.564,209.217 c-1.608,4.413-4.834,7.938-9.095,9.924c-2.356,1.101-4.854,1.656-7.423,1.656c-6.817,0-13.082-3.989-15.958-10.16 c-4.098-8.798-0.282-19.288,8.511-23.389c2.354-1.098,4.852-1.651,7.418-1.651c6.817,0,13.082,3.987,15.96,10.165 C143.959,200.024,144.169,204.802,142.564,209.217z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M134.803,164.575c0.852,1.831,2.394,3.244,4.291,3.936c0.842,0.304,1.725,0.459,2.602,0.459 c1.101,0,2.199-0.238,3.216-0.713l87.572-40.838c1.831-0.852,3.244-2.397,3.936-4.294c0.687-1.897,0.596-3.989-0.256-5.818 l-37.254-79.89c-1.775-3.807-6.297-5.453-10.109-3.68l-87.572,40.835c-1.829,0.852-3.244,2.397-3.934,4.294 c-0.69,1.897-0.599,3.989,0.254,5.818L134.803,164.575z M188.334,50.746l30.822,66.095l-73.778,34.408L114.557,85.15 L188.334,50.746z"
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgDeliveryCart = function SvgDeliveryCart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 253.643 253.643",
    style: {
      enableBackground: "new 0 0 253.643 253.643"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeliveryCart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delivery-cart.33b49b81.svg";
export { ForwardRef as ReactComponent };